// 正式环境配置文件
export const API_ROOT = 'https://oa.fancydigital.com.cn/api';


// WEBPACK FOOTER //
// ./src/config.prod.js